export class MarketingPreferencesConfig {
  constructor(phoneEnabled, emailEnabled, smsEnabled, postEnabled) {
    this.phoneMarketingAllowed = phoneEnabled;
    this.emailMarketingAllowed = emailEnabled;
    this.smsMarketingAllowed = smsEnabled;
    this.postMarketingAllowed = postEnabled;
  }

  pressPhone() {
    return new MarketingPreferencesConfig(
      !this.phoneMarketingAllowed,
      this.emailMarketingAllowed,
      this.smsMarketingAllowed,
      this.postMarketingAllowed,
    );
  }

  pressEmail() {
    return new MarketingPreferencesConfig(
      this.phoneMarketingAllowed,
      !this.emailMarketingAllowed,
      this.smsMarketingAllowed,
      this.postMarketingAllowed,
    );
  }

  pressSms() {
    return new MarketingPreferencesConfig(
      this.phoneMarketingAllowed,
      this.emailMarketingAllowed,
      !this.smsMarketingAllowed,
      this.postMarketingAllowed,
    );
  }

  pressPost() {
    return new MarketingPreferencesConfig(
      this.phoneMarketingAllowed,
      this.emailMarketingAllowed,
      this.smsMarketingAllowed,
      !this.postMarketingAllowed,
    );
  }
}
